import { createSlice } from '@reduxjs/toolkit';
import { globalState as initialState } from './state';
import { globalData } from './reducers';

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    ...globalData,
  },
});

export const globalActions = globalSlice.actions;
